import { render, staticRenderFns } from "./publishRFCCloseNumGroupe.vue?vue&type=template&id=3685ecfa&scoped=true&"
import script from "./publishRFCCloseNumGroupe.vue?vue&type=script&lang=js&"
export * from "./publishRFCCloseNumGroupe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3685ecfa",
  null
  
)

export default component.exports